  // Initialize Firebase
  export const config = {
    apiKey: "AIzaSyAnt4FsXS3OC8gAX_P7BXqKdiIMJppgOWg",
    authDomain: "s2-move.firebaseapp.com",
    databaseURL: "https://s2-move.firebaseio.com",
    projectId: "s2-move",
    storageBucket: "s2-move.appspot.com",
    messagingSenderId: "871367035764"
  };



//////////////////
// WEBPACK FOOTER
// ./helpers/firebaseconfig.js
// module id = null
// module chunks = 